import SEO from './SEO';
import { buildUrl } from '../../config/seo';

const HomeSEO = () => {
  return (
    <SEO
      title="Web Developer Interview Questions - React, JavaScript, TypeScript & More"
      description="Master your next frontend interview with comprehensive questions and answers covering React, JavaScript, TypeScript, CSS, OOP, React Native, Scrum, and live coding. Real interview questions with detailed explanations."
      keywords="web developer interview, frontend interview questions, React interview, JavaScript interview, TypeScript interview, CSS interview, React Native interview, OOP interview, Scrum interview, live coding interview, coding interview preparation, developer interview guide"
      url={buildUrl('/')}
      structuredData={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Web Developer Interview Questions",
        "description": "Comprehensive collection of web developer interview questions and answers",
        "url": buildUrl('/'),
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": buildUrl('/')
            }
          ]
        },
        "mainEntity": {
          "@type": "ItemList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "React Interview Questions" },
            { "@type": "ListItem", "position": 2, "name": "JavaScript Interview Questions" },
            { "@type": "ListItem", "position": 3, "name": "TypeScript Interview Questions" },
            { "@type": "ListItem", "position": 4, "name": "CSS Interview Questions" },
            { "@type": "ListItem", "position": 5, "name": "React Native Interview Questions" },
            { "@type": "ListItem", "position": 6, "name": "OOP Interview Questions" },
            { "@type": "ListItem", "position": 7, "name": "Live Coding Questions" },
            { "@type": "ListItem", "position": 8, "name": "Scrum Interview Questions" }
          ]
        }
      }}
    />
  );
};

export default HomeSEO;